import './TfrClassification.scss';

export { default } from './TfrClassification';
